import { render, staticRenderFns } from "./EdgeboxAddEdit.vue?vue&type=template&id=20a91cd1&scoped=true"
import script from "./EdgeboxAddEdit.vue?vue&type=script&lang=js"
export * from "./EdgeboxAddEdit.vue?vue&type=script&lang=js"
import style0 from "./EdgeboxAddEdit.vue?vue&type=style&index=0&id=20a91cd1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a91cd1",
  null
  
)

export default component.exports